import { Lightning, Utils } from "@lightningjs/sdk";
import { Row } from "./Row";
const asset = (name) => Utils.asset(`images/latest-replay/${name}`);
export class ReplayRow extends Row {
    createCard(item) {
        return Object.assign(Object.assign({}, super.createCard(item)), { duration: item.duration, PosterContainer: {
                Glow: {
                    x: -6,
                    y: -5,
                    w: 134,
                    h: 190,
                    clipping: true,
                    Large: {
                        x: -25.5,
                        y: -24,
                        w: 171.8,
                        h: 243.8,
                        texture: Lightning.Tools.getSvgTexture(asset("glow-large.svg"), 344, 488),
                    },
                    Medium: {
                        x: -33.6,
                        y: 6.4,
                        w: 128.8,
                        h: 177,
                        texture: Lightning.Tools.getSvgTexture(asset("glow-medium.svg"), 258, 354),
                    },
                    Small: {
                        x: -41.8,
                        y: 25.7,
                        w: 112.5,
                        h: 134.8,
                        texture: Lightning.Tools.getSvgTexture(asset("glow-small.svg"), 225, 270),
                    },
                },
                Duration: {
                    x: 299,
                    y: 131,
                    Background: { color: 0xff494947, alpha: 0.6 },
                    Label: {
                        text: {
                            fontFace: "Roboto",
                            fontSize: 18,
                            precision: 1,
                            h: 23,
                            lineHeight: 23,
                            offsetY: 18,
                        },
                    },
                },
            } });
    }
}
export default ReplayRow;
//# sourceMappingURL=ReplayRow.js.map